import { isObject } from 'lodash';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Dimmer, Grid, Icon, Loader } from 'semantic-ui-react';
import { heightSet, rowBodyHeightSet } from '../../../utilities/heightSet';
import { fetchArchive, fetchDownloadData } from '../data/actions';
import { searchColumns } from '../data/model';
import { getFilteredArchive, getIsArchiveFetched, getIsDownloadFetched } from '../data/selectors';
import { TableListDiv } from './tableListDiv';
import { ToastContainer, toast } from 'react-toastify';

const ArchiveList = (props) => {
    const [heights, setHeight] = useState('')
    const [getBodyHeight, setGetBodyHeight] = useState('')
    const Archive = useSelector(state => getFilteredArchive(state, props))
    const downloadMsg = useSelector(state => getIsDownloadFetched(state, props))
    const ArchiveFetched = useSelector(state => getIsArchiveFetched(state, props))
    const [isLoading, setIsLoading] = useState(false)
    const dispatch = useDispatch()

    useEffect(() => {
        if (!ArchiveFetched) {
            dispatch(fetchArchive())
        }
    }, [])

    useEffect(() => {
        if (downloadMsg) {
            toast.success(downloadMsg, {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }
    }, [downloadMsg])

    const callHeightFunc = () => {
        heightSet(setHeight)
        rowBodyHeightSet(setGetBodyHeight)
    }


    function downloadZip(archive) {
        if (isObject(archive)) {
            if (archive.link !== undefined && archive.link !== null && archive.link !== "") {
                setIsLoading(true)
                dispatch(fetchDownloadData(archive.link, setIsLoading))
            }
        }
    }

    const ArchiveAction = ({ object: archive }) => {
        return (
            <>
                <span>&nbsp;&nbsp;</span> <span>&nbsp;&nbsp;</span>
                {
                    <>
                        <Icon name='file archive' size="big" link onClick={() => { downloadZip(archive) }} />
                    </>
                }
            </>
        )
    }

    return (
        <>
            <div style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "10px 4px 12px",
            }}>
                <div>
                    <div style={{ fontSize: "17px", fontWeight: 600, color: "#1f2d3d", lineHeight: 1.2 }}>
                        Archive Data
                    </div>
                    <div style={{ fontSize: "12px", color: "#8a96a8", marginTop: "2px" }}>
                        Download archived data files.
                    </div>
                </div>
            </div>
            {(isLoading) ?
                <Dimmer active>
                    <Loader indeterminate>Downloading Files</Loader>
                </Dimmer>
                :
                <></>
            }
            {
                ArchiveFetched === false ?
                    <div style={{ height: '80vh', weight: '100%' }}>
                        Loading...
                    </div>
                    :
                    <div className='' style={{ paddingTop: "10px" }}>
                        <TableListDiv
                            columns={searchColumns}
                            data={Archive}
                            Actions={ArchiveAction}
                            setHeight={parseFloat(heights) - 80}
                            getIndex={1}
                            filterBoxNone={''}
                            rightBox={''}
                            centerBox={''}
                            callHeightFunc={callHeightFunc}
                            paddingShort={2}
                            getWidth={'100%'}
                            actionClass={"ArchiveAction"}
                        />
                    </div>
            }
            <ToastContainer />
        </>
    )
}

export default ArchiveList;